import { capitalize } from "lodash-es";

import { UserRoomLocation, UserBooleanAttribute, UserElevatorProximity } from "Bands/types";
import { copy } from "shared/assets";
import { IFieldType, IFormFields } from "shared/types";

const { userHotelPreferences } = copy;

export const fields: IFormFields = [
  {
    name: "hotelPreferences.smokingRoom",
    label: userHotelPreferences.fields.smokingRoom,
    type: IFieldType.radioGroup,
    options: [
      {
        label: "Yes",
        value: UserBooleanAttribute.yes,
      },
      {
        label: "No",
        value: UserBooleanAttribute.no,
      },
    ],
  },
  {
    name: "hotelPreferences.accessibleRoom",
    label: userHotelPreferences.fields.accessibleRoom,
    type: IFieldType.radioGroup,
    options: [
      {
        label: "Yes",
        value: UserBooleanAttribute.yes,
      },
      {
        label: "No",
        value: UserBooleanAttribute.no,
      },
    ],
  },
  {
    name: "hotelPreferences.roomLocation",
    label: userHotelPreferences.fields.roomLocation.title,
    placeholder: userHotelPreferences.fields.roomLocation.placeholder,
    type: IFieldType.select,
    options: (Object.keys(UserRoomLocation) as Array<keyof typeof UserRoomLocation>).map(key => ({
      value: UserRoomLocation[key],
      label: capitalize(UserRoomLocation[key].replaceAll("_", " ")),
    })),
  },
  {
    name: "hotelPreferences.elevatorProximity",
    label: userHotelPreferences.fields.elevatorProximity.title,
    placeholder: userHotelPreferences.fields.elevatorProximity.placeholder,
    type: IFieldType.select,
    options: (Object.keys(UserElevatorProximity) as Array<keyof typeof UserElevatorProximity>).map(
      key => ({
        value: UserElevatorProximity[key],
        label: capitalize(UserElevatorProximity[key].replaceAll("_", " ")),
      })
    ),
  },
];
